<template>
  <form-wrap
    class="password-settings"
    @submit="handleUpdate"
  >
    <section-title v-t="'p.passwordSettings.title'"/>
    <form-field-set legend="">
      <text-input
        v-model="currentPassword"
        :error="fieldError('update', 'currentPassword')"
        :label="$t('p.passwordSettings.form.label.currentPassword')"
        name="currentPassword"
        type="password"
      />

      <text-input
        v-model="password"
        :error="fieldError('update', 'password')"
        :label="$t('p.passwordSettings.form.label.password')"
        name="password"
        type="password"
      />

      <text-input
        v-model="passwordConfirmation"
        :error="fieldError('update', 'passwordConfirmation')"
        :label="$t('p.passwordSettings.form.label.passwordConfirmation')"
        name="passwordConfirmation"
        type="password"
      >
        <security-indicator
          slot="addon"
          :percent="percentNumber"
          class="password-indicator"
        />
      </text-input>
    </form-field-set>
    <form-actions>
      <button-input
        v-t="'p.passwordSettings.form.action.submit'"
        type="submit"
      />
    </form-actions>
  </form-wrap>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import zxcvbn from 'zxcvbn'
import SecurityIndicator from '@/components/forms/SecurityIndicator'
import FormMixin from '@/mixins/forms/Form'
import NotificationsMixin from '@/mixins/notifications/notifications'
import PageMixin from '@/mixins/pages/Page'

export default {
  name: 'PasswordSettings',
  mixins: [
    FormMixin,
    NotificationsMixin,
    PageMixin
  ],
  components: {
    SecurityIndicator
  },
  computed: {
    ...mapGetters({
      currentUserId: 'currentUserId',
      fieldError: 'passwordForm/fieldError'
    }),
    currentPassword: {
      get () { return this.$store.state.passwordForm.form.currentPassword },
      set (value) { this.$store.dispatch('passwordForm/setCurrentPassword', value) }
    },
    password: {
      get () { return this.$store.state.passwordForm.form.password },
      set (value) { this.$store.dispatch('passwordForm/setPassword', value) }
    },
    passwordConfirmation: {
      get () { return this.$store.state.passwordForm.form.passwordConfirmation },
      set (value) { this.$store.dispatch('passwordForm/setPasswordConfirmation', value) }
    },
    score () {
      return zxcvbn(this.password).score
    },
    percentNumber () {
      return this.score > 0
        ? this.score * 25
        : 0
    }
  },
  methods: {
    ...mapActions({
      update: 'passwordForm/update',
      resetUpdateErrors: 'passwordForm/resetUpdateErrors',
      loadingDone: 'app/loadingDone'
    }),
    handleUpdate () {
      return this.update({ userId: this.currentUserId })
        .then(this.reset)
        .then(this.savedNotification)
        .catch(this.somethingWentWrongNotification)
    },
    reset () {
      this.currentPassword = ''
      this.password = ''
      this.passwordConfirmation = ''
      this.resetUpdateErrors()
    }
  },
  created () {
    this.loadingDone()
  },
  beforeDestroy () {
    this.reset()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/PasswordSettings.vue